<template>
  <div>
    <b-navbar toggleable="sm" class="menu pl-2" id='main'>
      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

      <!-- <b-navbar-brand>BootstrapVue</b-navbar-brand> -->

      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item class="ml-4" to="/" active>INÍCIO</b-nav-item>
          <b-nav-item class="ml-4" to="/obras">OBRAS</b-nav-item>
          <!-- <b-nav-item class="ml-4" to="/areas">ÁREAS</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view></router-view>

    <Rodape />
    
  </div>
</template>

<script>

import MainInicio from '@/components/pagina-inicial/MainInicio'
import Rodape from '@/components/Rodape'

export default {
  name: 'Menu',
  components: {
    MainInicio,
    Rodape
  }
}
</script>

<style scoped>

.menu {
  background-color: #f6f6f6;
  padding: 15px 0;
}
.menu a {
  color: #777;
  border-bottom:2px solid transparent;
  font-weight: 400;
  width: 70px;
}
.menu a:hover {
  border-bottom: 2px solid #443c28;
  width: 70px;
  transition: .9s;
}
.menu a:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
}
.router-link-exact-active{
  border-bottom: 2px solid #443c28 !important;
  width: 70px;
  
}

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue